/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Tl_Anchor_LabelInputs */

const en_tl_anchor_label = /** @type {(inputs: Tl_Anchor_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`no dates, due with its milestone on ${i?.date}`)
};

const de_tl_anchor_label = /** @type {(inputs: Tl_Anchor_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ohne Termine, fällig mit dem Meilenstein am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "no dates, due with its milestone on {date}" |
*
* @param {Tl_Anchor_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_anchor_label = /** @type {((inputs: Tl_Anchor_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Anchor_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_anchor_label(inputs)
	return en_tl_anchor_label(inputs)
});